export default __webpack_public_path__ + "static/media/completed.6d1d2d9e.svg";